import { COLORS } from 'helpers/globals'

const row = {
  display: 'flex',
  margin: '.5rem 1rem',
  alignItems: 'center',
  fontSize: '1.6rem'
}

export default {
  firstRow: {
    ...row,
    flexDirection: 'row',
    alignItems: 'center'
  },
  mobileFirstRow: {
    ...row,
    flexDirection: 'column',
    alignItems: 'flex-start'
  },
  container: {
    display: 'flex',
    flexDirection: 'column',
    margin: ({ isMobile }) => isMobile ? '1rem' : 0
  },
  label: {
    display: 'flex',
    alignItems: 'center',
    fontWeight: '300',
    width: '100%',
    justifyContent: 'space-between',
    '& span': {
      paddingRight: '1rem'
    },
    '& a': {
      marginLeft: '1rem',
      padding: '.4rem',
      fontSize: '1.4rem',
      border: '1px solid #2972B1',
      borderRadius: '.5rem',
      '&:hover': { color: 'white', background: COLORS.primary }
    },
    '&.disabled': {
      color: '#ADB9C3'
    },
    '& a.disabled': {
      color: '#ADB9C3',
      border: '1px solid #ADB9C3',
      cursor: 'default',
      '&:hover': { color: '#ADB9C3', background: 'white', cursor: 'default' }
    }
  },
  inputWrapper: {
    flex: '0 1 auto',
    marginRight: 0,
    display: 'flex',
    fontSize: '1.2rem',
    fontWeight: 400,
    margin: ({ isMobile }) => isMobile ? 'auto' : 0,
    '&:hover': { cursor: 'pointer' }
  },
  viewChoice: {
    padding: '0.4rem 0.8rem',
    borderTop: '1px solid #2972B1',
    borderBottom: '1px solid #2972B1',
    '&:first-of-type': {
      borderRadius: '.75rem 0 0 .75rem',
      borderLeft: '1px solid #2972B1'
    },
    '&:last-of-type': {
      borderRadius: '0 .75rem .75rem 0',
      borderRight: '1px solid #2972B1'
    },
    '&:not(:last-of-type)': { borderRight: `2px solid ${COLORS.secondary}` },
    color: COLORS.primary,
    background: 'white',
    '&:hover:not(.selected)': {
      color: 'white',
      background: COLORS.primary
    },
    '&.selected': {
      color: 'white',
      background: COLORS.primary,
      '&:hover': { cursor: 'not-allowed' }
    }
  },
  row,
  indentedRow: {
    ...row,
    marginLeft: '3rem'
  },
  switch: {
    marginRight: ({ isMobile }) => isMobile ? 0 : '8rem'
  }
}



// WEBPACK FOOTER //
// ./src/components/ViewOptionsPanel/style.js